import * as React from 'react';
import {
  connect,
  TAdFoxBannerProps as TAdFoxBannerComponentProps,
  IAdFoxBannerOnLoadData,
} from '@cian/adfox-component';
import { OwnTemplates } from './components/OwnTemplates';

const AdFoxBannerComponent = connect(OwnTemplates);

type TAdFoxBannerProps = TAdFoxBannerComponentProps & {
  disableYan?: boolean;
  onRenderError?(error: Error): void;
};

interface IAdFoxBannerState {
  isHidden: boolean;
}

export class AdfoxBanner extends React.Component<TAdFoxBannerProps, IAdFoxBannerState> {
  public state: IAdFoxBannerState = {
    isHidden: false,
  };

  public componentDidCatch(error: Error) {
    const { onRenderError } = this.props;

    if (onRenderError) {
      onRenderError(error);
    }
  }

  public render() {
    const { disableYan, ...sharedProps } = this.props;
    const { isHidden } = this.state;

    if (disableYan && isHidden) {
      return null;
    }

    return <AdFoxBannerComponent {...sharedProps} onLoad={this.handleLoad} />;
  }

  private handleLoad = (data: IAdFoxBannerOnLoadData) => {
    const { bundleName } = data;
    const { disableYan, onLoad } = this.props;

    if (disableYan && bundleName === 'banner.direct') {
      this.setState({
        isHidden: true,
      });
    }

    if (onLoad) {
      onLoad(data);
    }
  };
}
